import { $t } from "@/plugins/i18n";
import { home } from "@/router/enums";
const Layout = () => import("@/layout/index.vue");
import homeIcon from "@/assets/svg/home.svg?component";
export default {
  path: "/",
  name: "Home",
  component: Layout,
  redirect: "/inspirationLibrary/index",
  meta: {
    icon: homeIcon,
    title: $t("menus.pureHome"),
    rank: home
  },
  children: []
} satisfies RouteConfigsTable;
